import { render, staticRenderFns } from "./AudienceFilterBrickConditionField.vue?vue&type=template&id=5245836f&scoped=true&"
import script from "./AudienceFilterBrickConditionField.vue?vue&type=script&lang=js&"
export * from "./AudienceFilterBrickConditionField.vue?vue&type=script&lang=js&"
import style0 from "./AudienceFilterBrickConditionField.vue?vue&type=style&index=0&id=5245836f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245836f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5245836f')) {
      api.createRecord('5245836f', component.options)
    } else {
      api.reload('5245836f', component.options)
    }
    module.hot.accept("./AudienceFilterBrickConditionField.vue?vue&type=template&id=5245836f&scoped=true&", function () {
      api.rerender('5245836f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/AudienceFilter/AudienceFilterBrickConditionField.vue"
export default component.exports